import React, { useState, useContext, useEffect } from "react";
import UserConfigNewUserStyled from "../../../assets/css/components/admin/user-config/UserConfigNewUser.css";
import { GlobalContext } from "../../../contexts/GlobalContext";
import { Link } from "react-router-dom";
import {
  Form,
  Row,
  Col,
  Container,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import {
  keyUserId,
  keyAccessToken,
} from "../../../assets/js/SessionStorageNames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import { Redirect } from "react-router-dom";
import verifyAccessRole from "../../../assets/js/verifyAccessRole";
import Routes from "../../../Routes";

export default function UserConfigNewUser() {
  const globalContext = useContext(GlobalContext);

  const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
  const [name, setName] = useState("");
  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");
  const [checkPassword, setCheckPassword] = useState("");
  const [enterprises, setEnterprises] = useState([]);
  const [enterprisesOptions, setEnterprisesOptions] = useState([]);
  const [formSave, setFormSave] = useState("active");
  const [goodSave, setGoodSave] = useState(null);
  const [erroSave, setErrorSave] = useState(null);
  const [rolRoute, setRoles] = useState(null);
  const [redirect, setRedirect] = useState(null);
  const [dailyGoalForKbt, setDailyGoalForKbt] = useState('');
  const [isKbtUser, setIsKbtuser] = useState(false);
  const [country, setcountry] = useState('');
  const [third, setThird] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [newOdooId, setNewOdooId] = useState('');
  const [isPurchaseUser, setIsPurchaseUser] = useState(false);

  const rolesSend = [
    {id: 'SuperAdmin', name: 'SuperAdmin'},
    {id: 'Admin', name: 'Admin'},
    {id: 'Gerente', name: 'Gerente'},
    {id: 'Champion', name: 'Champion'},
    {id: 'Champion2', name: 'Champion2'},
    {id: 'Proveedor', name: 'Proveedor'},
    {id: 'Preguntas', name: 'Preguntas'},
  ];

  useEffect(() => {
    const hasAccess = verifyAccessRole(Routes, 7);
    if(!hasAccess) {
        setRedirect(
            <Redirect to={`/admin/dashboard`} />
        )
    }
},[]);

  // Función para agregar ID de Odoo
  const addOdooId = () => {
    if (newOdooId.trim() && !suppliers.some(supplier => supplier.id === parseInt(newOdooId))) {
      const newSupplier = {
        id: parseInt(newOdooId),
        consignment: false
      };
      setSuppliers([...suppliers, newSupplier]);
      setNewOdooId('');
    }
  };

  // Función para remover ID de Odoo
  const removeOdooId = (idToRemove) => {
    setSuppliers(suppliers.filter(supplier => supplier.id !== idToRemove));
  };

  // Función para cambiar estado de consignación de un proveedor específico
  const toggleSupplierConsignment = (supplierId) => {
    setSuppliers(suppliers.map(supplier => 
      supplier.id === supplierId 
        ? { ...supplier, consignment: !supplier.consignment }
        : supplier
    ));
  };

  // Función para manejar cambio de rol
  const handleRoleChange = (role) => {
    setRoles(role);
    if (role === 'Proveedor') {
      setThird(true); // Bloquear rol de terceros a true
    } else {
      // Limpiar estados de proveedor al cambiar a otro rol
      setSuppliers([]);
      setIsPurchaseUser(false);
      setNewOdooId('');
    }
  };

  // Función para manejar cambio de usuario de compras
  const handlePurchaseUserChange = (isPurchase) => {
    setIsPurchaseUser(isPurchase);
    if (isPurchase) {
      // Usuario de compras siempre usa ID 0 y no es consignación
      setSuppliers([{ id: 0, consignment: false }]);
    } else {
      // Limpiar proveedores si no es usuario de compras
      setSuppliers([]);
    }
  };

  // Función para resetear el formulario
  const resetForm = () => {
    setName("");
    setCorreo("");
    setPassword("");
    setCheckPassword("");
    setEnterprises([]);
    setSuppliers([]);
    setNewOdooId('');
    setIsPurchaseUser(false);
    setRoles(null);
    setThird(false);
    setcountry('');
    setIsKbtuser(false);
    setDailyGoalForKbt('');
  };
  const saveUser = (e) => {
    e.preventDefault();
    
    globalContext.setLoaderPage(true);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/v1/signup/new-user`,
      cancelToken: axiosCancelTokenSource.token,
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-access-token": localStorage.getItem(keyAccessToken),
        "x-user-id": localStorage.getItem(keyUserId),
      },
      data: {
        name: name,
        email: correo,
        password: password,
        rolRoute: rolRoute,
        enterprises: enterprises,
        ...( dailyGoalForKbt.length > 0 && {dailyGoalForKbt:parseInt(dailyGoalForKbt)}),
        isKbtUser: isKbtUser,
        country: country,
        third,
      },
    })
    .then((res) => {
      setErrorSave(null);
      
      // Si el rol es proveedor y hay proveedores, llamar al endpoint de validación
      if (rolRoute === 'Proveedor' && suppliers.length > 0) {
        const userId = res.data.data.user._id;
        const entId = globalContext.currentEnterpriseId; // ID de la empresa actual
        
        // Crear promesas para cada proveedor
        const validationPromises = suppliers.map(supplier => 
          axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND_URL}/v1/odoo-owner/${entId}/validate-supplier-profile`,
            cancelToken: axiosCancelTokenSource.token,
            headers: {
              "x-api-key": process.env.REACT_APP_API_KEY,
              "x-access-token": localStorage.getItem(keyAccessToken),
              "x-user-id": localStorage.getItem(keyUserId),
            },
            data: {
              userId: userId,
              odooSupplierId: supplier.id,
              consignment: supplier.consignment
            },
          })
        );
        
        // Retornar Promise.all para integrarlo en la cadena de promesas
        return Promise.all(validationPromises)
          .then(() => {
            setGoodSave("active");
            resetForm();
          })
          .catch((err) => {
            console.log('Error en validación de proveedores:', err);
            // Usuario creado pero validación de proveedor falló - mostrar error
            setErrorSave("active");
            // No resetear el formulario para que el usuario pueda ver qué proveedor falló
            console.error('Usuario creado exitosamente pero la validación de proveedor(es) falló:', err.message);
          });
      } else {
        setGoodSave("active");
        resetForm();
      }
    })
    .catch((err) => {
      if (axios.isCancel(err)) return; //Don't show axios cancel error
      setGoodSave(null);
      console.log(err);
      setErrorSave("active");
    })
    .finally(() => {
      globalContext.setLoaderPage(false);
      setFormSave("");
    });
  };

  /**
   * Load the enterprises list
   */
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/v1/enterprise/`, {
      params: {
        pageNumber: 1,
        pageItemCount: 500,
      },
      cancelToken: axiosCancelTokenSource.token,
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-access-token": localStorage.getItem(keyAccessToken),
        "x-user-id": localStorage.getItem(keyUserId),
      },
    }).then((res) => {
      setEnterprisesOptions(res.data.data.enterprises);
    })
    .catch((err) => {
      if (axios.isCancel(err)) return; //Don't show axios cancel error
      globalContext.showModalWithMsg('Disculpe ha ocurrido un error al intentar cargar la lista de empresas');
      console.log(err, err.response);
    });
  }, []);

  /**
   * Cancel axios requests before unmount
   */
  useEffect(() => {
    return () => {
      axiosCancelTokenSource.cancel("Canceled by unmount");
    };
    //eslint-disable-next-line
  }, []);

  return (
    <UserConfigNewUserStyled>
      {redirect}
      <div className="goBack d-flex justify-content-start mt-2">
        <Link to="/admin/user-config/dashboard">
          <button className="btn-back">
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>
        </Link>
      </div>
      <div className="NewUserCont mt-5 mb-5">
        <div className={`form-user ${formSave}`}>
          <Form onSubmit={saveUser}>
            <Container>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <p className="h3">Nuevo Usuario</p>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                  <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                      <InputGroup.Text id="basic-addon1">
                        Nombre
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                      value={name}
                      placeholder="Ingrese el nombre"
                      aria-label="Ingrese el nombre"
                      aria-describedby="basic-addon1"
                      onChange={(e) => setName(e.target.value)}
                    />
                  </InputGroup>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                  <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                      <InputGroup.Text id="basic-addon2">
                        Correo
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                      value={correo}
                      placeholder="Ingrese la direccion de correo"
                      aria-label="Ingrese la direccion de correo"
                      aria-describedby="basic-addon2"
                      onChange={(e) => setCorreo(e.target.value)}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                  <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                      <InputGroup.Text id="basic-addon3">Clave</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                      value={password}
                      placeholder="Ingrese su clave de acceso"
                      aria-label="Ingrese su clave de acceso"
                      aria-describedby="basic-addon3"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </InputGroup>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                  <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                      <InputGroup.Text id="basic-addon4">Clave</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                      value={checkPassword}
                      placeholder="Confirme su clave de acceso"
                      aria-label="Confirme su clave de acceso"
                      aria-describedby="basic-addon4"
                      onChange={(e) => setCheckPassword(e.target.value)}
                    />
                  </InputGroup>
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Form.Group>
                    <Form.Label>Role a asignar</Form.Label>
                    <Form.Control
                      defaultValue={rolRoute}
                      as="select"
                      onChange={e => handleRoleChange(e.target.value)}
                    >
                      <option value="">Seleccione uno</option>
                      {
                        rolesSend.map(e => <option key={e.id} value={e.id}>{e.name}</option>)
                      }
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Form.Group>
                    <Form.Label>Rol de Terceros</Form.Label>
                    <Form.Control
                      value={third}
                      as="select"
                      onChange={(e) => setThird(e.target.value)}
                      disabled={rolRoute === 'Proveedor'}
                    >
                      <option value={false} >No</option>
                      <option value={true} >Sí</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Form.Group>
                    <Form.Label>Pais</Form.Label>
                    <Form.Control
                      value={country}
                      as="select"
                      onChange={e => setcountry(e.target.value)}
                    >
                      <option value="">Seleccione uno</option>
                      <option value='VE'>VE</option>
                      <option value='CO'>CO</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Form.Group>
                    <Form.Label>Es usuario de KBT?</Form.Label>
                    <Form.Control
                      value={isKbtUser}
                      as="select"
                      onChange={e => setIsKbtuser(e.target.value)}
                    >
                      <option value="">Seleccione uno</option>
                      <option value={true}>Si</option>
                      <option value={false}>No</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                {
                  isKbtUser && (
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <InputGroup className="mb-3">
                    <Form.Label>Meta diaria</Form.Label>
                    <FormControl
                      value={dailyGoalForKbt}
                      placeholder="Meta diaria"
                      aria-label="Meta diaria"
                      aria-describedby="basic-addon4"
                      onChange={(e) => setDailyGoalForKbt(e.target.value)}
                    />
                  </InputGroup>
                </Col>
                  )
                }
              </Row>

              <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Form.Group>
                    <Form.Label>Empresas</Form.Label>
                    <Form.Control
                      value={enterprises}
                      as="select"
                      multiple
                      onChange={e => setEnterprises([...e.target.options].filter(o => o.selected).map(o => o.value))}
                    >
                      {
                        enterprisesOptions.map(e => <option key={e._id} value={e._id}>{e.name}</option>)
                      }
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              {/* Sección específica para proveedores */}
              {rolRoute === 'Proveedor' && (
                <>
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Form.Group>
                        <Form.Label>IDs de Proveedores Odoo</Form.Label>
                        <div className="d-flex mb-2">
                          <FormControl
                            value={newOdooId}
                            placeholder="Ingrese ID de Odoo"
                            onChange={(e) => setNewOdooId(e.target.value)}
                            disabled={isPurchaseUser}
                            type="number"
                            min="1"
                          />
                          <button
                            type="button"
                            className="btn btn-primary ml-2"
                            onClick={addOdooId}
                            disabled={isPurchaseUser || !newOdooId.trim()}
                          >
                            Agregar
                          </button>
                        </div>
                        {suppliers.length > 0 && (
                          <div className="mt-2">
                            {suppliers.map((supplier, index) => (
                              <div key={index} className="border p-2 mb-2 rounded">
                                <div className="d-flex justify-content-between align-items-center">
                                  <span className="badge badge-secondary p-2">
                                    ID: {supplier.id}
                                  </span>
                                  {!isPurchaseUser && (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-danger"
                                      onClick={() => removeOdooId(supplier.id)}
                                    >
                                      ×
                                    </button>
                                  )}
                                </div>
                                <div className="mt-2">
                                  <Form.Check
                                    type="checkbox"
                                    label="Es consignación"
                                    checked={supplier.consignment}
                                    onChange={() => toggleSupplierConsignment(supplier.id)}
                                    disabled={isPurchaseUser}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Form.Group>
                        <Form.Check
                          type="checkbox"
                          label="Es usuario de compras"
                          checked={isPurchaseUser}
                          onChange={(e) => handlePurchaseUserChange(e.target.checked)}
                        />
                        <small className="text-muted">
                          Los usuarios de compras siempre usan ID 0 y no son consignación
                        </small>
                      </Form.Group>
                    </Col>
                  </Row>
                </>
              )}

              <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <button className="btn-save-user">Guardar</button>
                </Col>
              </Row>
            </Container>
          </Form>
        </div>
        <div className={`save-screen ${goodSave}`}>
          <Container>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <p className="h2">Registro exitoso</p>
                <p className="save-register">
                  <FontAwesomeIcon icon={faCheckCircle} />
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <button
                  className="btn-add-again-user"
                  onClick={() => {
                    setGoodSave(null);
                    setErrorSave(null);
                    setFormSave("active");
                  }}
                >
                  Registrar otro
                </button>
              </Col>
            </Row>
          </Container>
        </div>
        <div className={`error-screen ${erroSave}`}>
          <Container>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <p className="h2">Lo sentimos algo salio mal!</p>
                <p className="error-register">
                  <FontAwesomeIcon icon={faTimesCircle} />
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <button
                  className="btn-add-again-user"
                  onClick={() => {
                    setErrorSave(null);
                    setGoodSave(null);
                    setFormSave("active");
                  }}
                >
                  Intentar de nuevo
                </button>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </UserConfigNewUserStyled>
  );
}
